import { useState, useEffect } from 'react';
import CalendarDatePickerComponent from './CalendarDatePicker.component';

type DatePickerType = {
  onSelectDate?: (date: Date, endDate?: null | Date) => void;
  isDateRange?: boolean;
};

const CalendarDatePicker = ({ onSelectDate, isDateRange }: DatePickerType): JSX.Element => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if ((startDate && !isDateRange) || (startDate && isDateRange && endDate)) {
      onSelectDate?.(startDate, endDate);
    }
  }, [startDate, endDate, onSelectDate, isDateRange]);

  const onChangeDatePicker = (dates): void => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const onChangeSingleDate = (date): void => {
    setStartDate(date);
    onSelectDate?.(date);
  };

  const dateRangeProps = {
    startDate,
    endDate,
    selectsRange: true,
  };

  return (
    <CalendarDatePickerComponent
      value={startDate || undefined}
      onChange={isDateRange ? onChangeDatePicker : onChangeSingleDate}
      inline
      {...(isDateRange ? dateRangeProps : {})}
    />
  );
};

export default CalendarDatePicker;
